import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../config';

/**
 * True for a new org: no applications and no tests yet. Derived from the same
 * list endpoints the rest of the app uses; stays false while loading or on
 * error so the welcome never flashes for an established org.
 */
export function useIsFirstRun(): boolean {
  const applications = useQuery({
    queryKey: ['properties'],
    queryFn: async (): Promise<{ items: unknown[] }> => {
      const r = await fetch(`${API_URL}/org/properties`, { credentials: 'include' });
      if (!r.ok) throw new Error('Failed to fetch applications');
      return r.json();
    },
    staleTime: 60_000,
  });
  const tests = useQuery({
    queryKey: ['workflows', 'first-run'],
    enabled: applications.data?.items?.length === 0,
    queryFn: async (): Promise<{ data: unknown[] }> => {
      const r = await fetch(`${API_URL}/workflows?page=1&pageSize=1`, { credentials: 'include' });
      if (!r.ok) throw new Error('Failed to fetch tests');
      return r.json();
    },
    staleTime: 60_000,
  });
  if (!applications.data || !tests.data) return false;
  return !applications.data.items?.length && !tests.data.data?.length;
}
